import { computed, defineComponent, reactive } from "vue";
import { useStore } from "vuex";
import { ElMessageBox, ElMessage } from "element-plus";
export default defineComponent({
  name: "userLogin",
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var store = useStore();
    store.dispatch("Login/getLoginStatus"); //每次获取用户登录状态

    var userInfo = computed(function () {
      return store.state.Login.userData;
    }); //明天

    var baseInfo = reactive([{
      count: userInfo.value.djStatus,
      title: "动态"
    }, {
      count: userInfo.value.followeds,
      title: "关注"
    }, {
      count: userInfo.value.follows,
      title: "粉丝"
    }]);
    var opearteInfo = reactive([{
      link: "https://music.163.com/#/member",
      icon: "icon-crown1",
      title: "会员中心"
    }, {
      link: "https://music.163.com/#/user/level",
      icon: "icon-MedalofHonor",
      title: "等级"
    }, {
      link: "https://music.163.com/store/product",
      icon: "icon-cart1",
      title: "商城"
    }]);
    /* 点击登录 */

    var loginClick = function loginClick() {
      emit("loginClick");
    };
    /* 退出登录 */


    var logoutClick = function logoutClick() {
      ElMessageBox.confirm("确定退出吗?", "退出确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-box"
      }).then(function () {
        store.dispatch("Login/getLogout");
        ElMessage({
          type: "success",
          message: "已退出登录"
        });
      }).catch(function () {
        ElMessage({
          type: "error",
          message: "已取消退出登录"
        });
      });
    };

    return {
      userInfo: userInfo,
      baseInfo: baseInfo,
      opearteInfo: opearteInfo,
      loginClick: loginClick,
      logoutClick: logoutClick
    };
  },
  components: {}
});